import React, { useEffect, useState } from "react";
import CohortCard from "./CohortCard";
import { useDispatch } from "react-redux";
import {
  setCohortApplied,
  setIsEditCohort,
  setResetSearchTextForAdditionalInstitutions,
  setResetSearchTextForCities,
  setSelectedCohort,
} from "../../../../rtk-query/features/cohort/cohortSlice";
import exportimages from "../../../../assets/images/exportImages";
import { fnCheckDollarUnits } from "../../report/widget/widgetsCommonFunction";

const SuggestedCohort = ({ cohortList }) => {
  const dispatch = useDispatch();
  const [validCohortList, setValidCohortList] = useState([]);

  useEffect(() => {
    setValidCohortList(cohortList?.filter((i) => i?.cohortType === 1));
  }, [cohortList]);

  const [showNoData, setShowNoData] = useState(false);
  useEffect(() => {
    if (validCohortList?.length === 0) {
      setTimeout(() => setShowNoData(true), 1000);
    } else {
      setShowNoData(false);
    }
  }, [validCohortList]);

  return (
    <div className="list-cohort flex-start">
      {validCohortList?.length > 0
        ? validCohortList?.map((cohort) => {
          const cohortResult = cohort?.cohortResult;
          const filterJson = cohort?.filterJson;
          const { score: minAssetSize, unit: minAssetSizeUnit } =
            fnCheckDollarUnits(Number(filterJson?.assets?.min) ?? 0);
          const { score: maxAssetSize, unit: maxAssetSizeUnit } =
            fnCheckDollarUnits(Number(filterJson?.assets?.max) ?? 0);

          return (
            cohort?.cohortType === 1 && (
              <div
                key={cohort?.uid}
                onClick={() => {
                  dispatch(setSelectedCohort(cohort));
                  dispatch(setCohortApplied(null));
                  dispatch(setIsEditCohort(false));
                  dispatch(setResetSearchTextForAdditionalInstitutions(true));
                  dispatch(setResetSearchTextForCities(true));
                }}
                className="w-100"
              >
                <CohortCard
                  uid={cohort?.uid}
                  title={cohort?.name}
                  subtitle={cohort?.description}
                  range={`$${minAssetSize?.toFixed(2)}${minAssetSizeUnit} – $${maxAssetSize?.toFixed(2)}${maxAssetSizeUnit}`}
                  // range={`$${filterJson?.assets?.min} – $${filterJson?.assets?.max}`}
                  institutions={cohortResult?.institution_count}
                  avg={cohortResult?.cohort_avg}
                  percentile={cohortResult?.percentile}
                />
              </div>
            )
          );
        })
        : showNoData && (
          <div className="message-container">
            <div className="message">
              <div className="no_cohort">
                <img alt="icon" src={exportimages.no_cohort} />
              </div>
              <div className="message">No Suggested Cohorts Yet</div>
              <div className="desc">System has not suggested any cohort.</div>
            </div>
          </div>
        )}
    </div>
  );
};

export default SuggestedCohort;
